import React from "react";
import { useState, useRef } from "react";
import { Col } from "antd";
import {
  CaretRightOutlined,
  AudioMutedOutlined,
  ExpandOutlined,
  PauseOutlined,
  AudioOutlined,
} from "@ant-design/icons";
import { RiVolumeUpLine, RiVolumeMuteLine } from "react-icons/ri";

const VideosPlayer = ({ src, title, poster }) => {
  const [isPlaying, setisPlaying] = useState(false);
  const [isMuted, setisMuted] = useState(false);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setisPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setisMuted(!isMuted);
    }
  };

  const handleFullScreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      }
    }
  };

  const handleVideoEnd = () => {
    setisPlaying(false);
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
    }
  };
  return (
    <Col className="p-0">
      <div className="relative">
        <video
          ref={videoRef}
          src={src}
          style={{
            width: "100%",
            aspectRatio: "16/9",
            objectFit: "cover",
            borderRadius: "10px",
            border: "1px solid var(--border-color)"
          }}
          poster={poster}
          onEnded={handleVideoEnd}
          onClick={togglePlay}
        />
        <div className="video-footer">
          <div className="d-flex font-15 text-white" style={{ gap: "12px" }}>
            <div className="videoplayer-btn cursor" onClick={togglePlay}>
              {isPlaying ? <PauseOutlined /> : <CaretRightOutlined />}
            </div>
            <div className="videoplayer-btn cursor" onClick={toggleMute}>
              {isMuted ? <RiVolumeMuteLine /> : <RiVolumeUpLine />}
            </div>
            <span style={{ width: "161px" }} className="ellipsis">
              {title}
            </span>
          </div>
          <div className="cursor font-15 text-white" onClick={handleFullScreen}>
            <div className="videoplayer-btn">
              <ExpandOutlined />
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default VideosPlayer;
